<app-split-card>
  <div split-card-content>
    <ng-container *ngIf="mode !== 'option'">
      <app-field *ngIf="mode !== 'pick'" [field]="nameField"></app-field>

      <div class="mat-headline-6">Average hours of production</div>
      <div class="vertical-inputs">
        <app-field [field]="hoursField"></app-field>
        <app-field [field]="minutesField"></app-field>
        <app-field [field]="perField"></app-field>
      </div>
    </ng-container>

    <span class="flex"></span>

    <div class="actions row" [ngSwitch]="mode" *ngIf="productionLine">
      <ng-container *ngSwitchCase="'option'">
        <app-button
          class="col-12"
          type="save"
          label="CREATE NEW"
          (buttonClick)="onModeSwitch('create')"
          *appIfCommandAvailable="'create_production_line'"
        >
        </app-button>
        <app-button
          class="col-12"
          type="add"
          label="PICK FROM INVENTORY"
          icon="search"
          (buttonClick)="showPicker()"
          [disabled]="!hasProductionLines"
        >
        </app-button>
      </ng-container>
      <app-button
        class="col-12"
        *ngSwitchCase="'view'"
        type="save"
        label="EDIT"
        icon="edit"
        (buttonClick)="edit.emit(productionLine)"
      >
      </app-button>
      <app-button
        class="col-12"
        *ngSwitchCase="'edit'"
        type="save"
        label="SAVE"
        icon="save"
        (buttonClick)="onSave()"
      >
      </app-button>
      <app-button
        class="col-12"
        *ngSwitchCase="'edit'"
        type="clear"
        label="CANCEL"
        (buttonClick)="cancel.emit()"
      >
      </app-button>
      <app-button
        class="col-12"
        *ngSwitchCase="'create'"
        type="save"
        [label]="createLabel"
        (buttonClick)="onSave()"
      >
      </app-button>
    </div>
  </div>

  <!-- Artwork -->
  <app-production-line-view
    [cpm]="cpm$ | async"
    split-card-artwork
  ></app-production-line-view>
</app-split-card>
